"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'featureFlags';
exports.SAVE_FEATURE_FLAG = exports.namespace + "/SAVE_FEATURE_FLAG";
exports.SAVE_ALL_FEATURE_FLAGS = exports.namespace + "/SAVE_ALL_FEATURE_FLAGS";
//# sourceMappingURL=constants.js.map